const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasteManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.057 512.057",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6B7F9E"
    },
    cx: 256.028,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FB379"
    },
    d: "M103.824,290.107h304.408V461.89c-42.563,31.496-95.17,50.167-152.204,50.167 s-109.641-18.671-152.204-50.167V290.107z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DA668"
    },
    points: "408.232,327.505 408.232,334.996 103.824,334.996 103.824,327.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DA668"
    },
    points: "90.602,326.143 103.824,357.299 103.824,327.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DA668"
    },
    points: "421.455,326.143 408.232,357.299 408.232,327.505  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FB379"
    },
    d: "M94.29,290.107h323.476c3.178,0,5.732,2.554,5.732,5.732v25.935c0,3.178-2.554,5.732-5.732,5.732 H94.29c-3.178,0-5.732-2.611-5.732-5.732v-25.935C88.559,292.661,91.169,290.107,94.29,290.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67BB87"
    },
    d: "M103.824,290.107h304.408l-19.976-151.296c-1.419-10.896-8.967-19.976-19.976-19.976H143.72 c-10.953,0-18.501,9.08-19.976,19.976l-19.976,151.296H103.824z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FB379"
    },
    d: "M138.499,270.585h235.059l-15.436-109.868c-1.135-7.888-6.924-14.471-15.436-14.471H169.257 c-8.456,0-14.301,6.583-15.436,14.471l-15.436,109.868H138.499z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4FB379"
    },
    points: "139.237,327.505 151.722,327.505 151.722,363.315 139.237,363.315  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DA668"
    },
    points: "151.722,327.505 158.475,334.996 151.722,363.315 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4FB379"
    },
    points: "372.82,327.505 360.335,327.505 360.335,363.315 372.82,363.315 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DA668"
    },
    points: "360.335,327.505 353.639,334.996 360.335,363.315 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4FB379"
    },
    points: "262.271,327.505 249.786,327.505 249.786,363.315 262.271,363.315 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DA668"
    },
    d: "M174.705,165.029c-11.01,13.053-23.495,42.449-33.426,105.555h-2.781l15.436-109.868 c1.135-7.888,6.924-14.471,15.436-14.471c57.828,0,115.6,0,173.428,0h0.397h0.397h0.397l0.397,0.057l0.397,0.057l0.397,0.057 l0.397,0.057l0.341,0.057l0.34,0.057l0.341,0.057l0.34,0.114l0.341,0.113l0.34,0.113l0,0l0.341,0.114l0,0l0.34,0.113l0,0 l0.341,0.114l0.34,0.113l0,0l0.341,0.17l0.341,0.17l0.284,0.17l0.284,0.17l0,0l0.284,0.17l0,0l0.284,0.17l0,0l0.284,0.17l0,0 l0.284,0.227l0,0l0.284,0.227l0,0l0.284,0.227l0,0l0.284,0.227l0,0l0.284,0.227l0,0l0.284,0.227l0,0l0.284,0.227l0,0l0.227,0.227 l0,0c0.17,0.17,0.341,0.34,0.511,0.511l0,0l0.227,0.284l0,0l0.227,0.284l0,0c0.227,0.284,0.454,0.568,0.681,0.851l0,0l0.227,0.284 l0,0l0.227,0.284l0,0c0.113,0.17,0.284,0.397,0.397,0.624l0,0l0.17,0.284l0,0l0.17,0.284l0,0l0.17,0.34l0,0l0.17,0.34l0,0 l0.17,0.34l0,0l0.17,0.34l0,0l0.17,0.34l0,0l0.113,0.34l0,0l0.113,0.341l0,0l0.113,0.34l0,0l0.113,0.34l0,0l0.114,0.34l0,0 l0.113,0.34l0,0l0.113,0.34l0,0l0.113,0.34l0,0l0.113,0.34l0.057,0.34l0,0l0.057,0.34l0,0l0.057,0.34l0.057,0.34l0.057,0.34 l15.436,109.868h-2.781c-9.931-63.106-22.416-92.503-33.426-105.555H174.876L174.705,165.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DA668"
    },
    d: "M256.028,379.205c31.95,0,57.885,25.935,57.885,57.885s-25.935,57.885-57.885,57.885 s-57.885-25.935-57.885-57.885S224.078,379.205,256.028,379.205z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE356"
    },
    d: "M256.028,383.12c29.794,0,53.969,24.176,53.969,53.969c0,29.794-24.176,53.969-53.969,53.969 s-53.969-24.176-53.969-53.969C202.059,407.296,226.235,383.12,256.028,383.12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56BF5D"
    },
    d: "M224.248,423.413l19.636-5.335l5.335,19.636l-4.54-2.611l-8.74,15.152h13.45h-13.45 c-6.64,11.634,1.816,19.295,14.982,19.295h-17.536c-6.243,0-11.634-3.121-14.755-8.513c-3.121-5.448-3.121-11.634,0-17.082 l10.329-17.876l-4.654-2.667H224.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56BF5D"
    },
    d: "M260.228,473.523l-14.471-14.301l14.301-14.471v5.505h16.004l0,0 c13.336,1.078,15.152-10.158,9.307-20.26l8.059,13.961c3.121,5.448,3.121,11.634,0,17.082c-3.121,5.448-8.513,8.513-14.755,8.513 h-18.501v3.973H260.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56BF5D"
    },
    d: "M270.84,404.742l8.796,15.209l4.824-2.781l-5.164,19.692l-19.692-5.164l4.313-2.554l-7.832-13.62 c-9.534-17.252-21.054,0.17-21.508,0.851l6.697-11.634c3.121-5.448,8.513-8.513,14.755-8.513s11.634,3.121,14.755,8.513H270.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0BA7D"
    },
    d: "M233.442,207.876l-8.456-22.076l12.769-7.491c0,0,4.256,16.855,5.278,27.297 c0.227,2.497-1.362,4.767-3.802,5.335S234.35,210.203,233.442,207.876z M245.7,198.172l-5.391-23.041l13.677-5.675 c0,0,1.93,17.309,1.589,27.751c-0.113,2.497-1.986,4.54-4.483,4.767s-4.767-1.362-5.335-3.802H245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M412.943,53.686l-84.615,42.109c0,0-0.057,0-0.057,0.057l-83.252,39.555 c-1.816,0.851-3.121,2.1-4.2,3.802l-26.162,39.385c-0.908,1.362-1.192,2.894-1.305,4.483l-2.327,29.453c0,0.057,0,0.17,0,0.227 c-1.646,13.28,8.796,9.307,9.704,5.959l7.491-28.035c0.738-2.724,2.327-4.767,4.767-6.129l49.373-27.694 c1.703-0.965,3.746-0.851,5.335,0.284c1.589,1.135,2.384,3.008,1.986,4.994l-5.391,28.659c-0.113,0.681-0.113,1.249,0,1.873 c1.816,9.08,11.918,3.462,14.698-3.348c0.057-0.17,0.17-0.34,0.227-0.511l23.495-42.449c1.249-2.327,3.178-3.859,5.675-4.654 L458.797,99.71C445.517,82.515,430.081,67.022,412.943,53.686z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEFEFE"
    },
    points: "258.015,220.247 270.5,211.224 291.327,217.58 300.01,236.137 297.626,251.687  286.844,260.483 276.742,253.333 263.803,260.2 247.913,247.714 239.344,250.041 242.692,230.519 253.134,224.958 262.384,228.363  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M276.969,189.319c0-0.624,0.511-1.192,1.192-1.192s1.192,0.511,1.192,1.192v13.62 c0,0.624-0.511,1.192-1.192,1.192c-0.624,0-1.192-0.511-1.192-1.192V189.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M259.547,195.675c0-0.624,0.511-1.192,1.192-1.192c0.624,0,1.192,0.511,1.192,1.192v13.62 c0,0.624-0.511,1.192-1.192,1.192s-1.192-0.511-1.192-1.192V195.675z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF0F1"
    },
    points: "287.865,216.559 294.164,237.783 279.069,246.693 271.862,234.208 265.506,235.91  256.142,234.038 265.789,247.147 253.475,248.395 247.856,241.075 241.103,239.996 239.344,250.041 247.913,247.714 263.803,260.2  276.742,253.333 286.844,260.483 297.626,251.687 300.01,236.137 291.327,217.58 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteManagement);
export default __webpack_public_path__ + "static/media/waste-management.87b704868178e888e7040c492da9fa61.svg";
export { ForwardRef as ReactComponent };